export const renderMinCharactersErrorMessage =
	(translate: (key: string) => string) =>
	({ min }: { min: number }) => {
		return `${translate("field-min-length-is")} ${min}`;
	};
